const ItemGetter = {
    items:      state => state.items,
    item:       state => state.item,
    categories: state => state.categories,
};

export default ItemGetter;